import { Auth } from 'aws-amplify';

const resolveUrl = (envUrl) => {
  const urls = envUrl.split(',');
  const hostname = window.location.hostname;
  const frontUrl = urls.find((url) => url.includes(hostname)) || urls[0];
  return frontUrl;
};

const awsmobile = {
  aws_project_region: 'eu-west-1',
  aws_cognito_identity_pool_id: process.env.REACT_APP_IDENTITY_POOL,
  aws_cognito_region: 'eu-west-1',
  aws_user_pools_id: process.env.REACT_APP_USER_POOL,
  aws_user_pools_web_client_id: process.env.REACT_APP_USER_POOLCLIENT,
  aws_user_files_s3_bucket: process.env.REACT_APP_USER_S3,
  aws_user_files_s3_bucket_region: 'eu-west-1',
  aws_appsync_graphqlEndpoint: process.env.REACT_APP_APPSYNC,
  aws_appsync_region: 'eu-west-1',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  FIRMA_FRONT_URL: resolveUrl(process.env.REACT_APP_FIRMA_FRONT_URL),
  REACT_APP_URL_TRAZER: resolveUrl(process.env.REACT_APP_URL_TRAZER),
  mandatorySignIn: true,
  cookieStorage: {
    // REQUIRED - Cookie domain (only required if cookieStorage is provided)
    domain: window.location.hostname,
    // OPTIONAL - Cookie path
    path: '/',
    // OPTIONAL - Cookie expiration in days
    expires: +process.env.REACT_APP_COOKIE_EXPIRATION || 0.04,
    // OPTIONAL - Cookie secure flag
    secure: true
  },
  Storage: {
    AWSS3: {
      bucket: process.env.REACT_APP_USER_S3, // REQUIRED -  Amazon S3 bucket name
      region: 'eu-west-1'
    }
  },
  API: {
    graphql_endpoint: process.env.REACT_APP_APPSYNC,
    graphql_headers: async () => ({ Authorization: (await Auth.currentSession())
      .getIdToken()
      .getJwtToken()
    }),
    endpoints: [
      {
        name: 'uruk-back',
        endpoint: process.env.REACT_APP_API_ENDPOINTS_URL,
        custom_header: async () => {
          let currentSession;
          try {
            currentSession = await Auth.currentSession();
          } catch (err) {
            console.log(err);
            window.location.reload();
          }
          const idToken = currentSession.getIdToken();
          return {
            Authorization: `Bearer ${idToken.getJwtToken()}`,
            'X-Api-Key': idToken.payload.apiKey
          };
        }
      }
    ]
  }
};

export default awsmobile;
